import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'unsafe'
})
export class UnsafePipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): unknown {
    return null;
  }

}
